import React, { PureComponent } from 'react';
import { connect } from 'react-redux';


class StacklaWidget extends PureComponent {

  componentDidMount(){
    if (process.env.NODE_ENV === "production") {
      if(typeof window.Stackla !== 'undefined'){
        window.Stackla.WidgetManager.rebuild();
      }
    }
  }



  render(){

    const _stacklaTag = this.props.filteredItinerary.map(item => item.cityInfo.stacklaTag);


    if (process.env.NODE_ENV === "production") {
      return (
        <div 
        className="stackla-widget" 
        data-tags={_stacklaTag}
        data-ct="" 
        data-hash="5de67b0311b80" 
        data-id="64957" 
        data-title="AP - Test - New" 
        data-ttl="60" 
        style={{width: "100%", overflow:"hidden"}}>
        </div>
      )
    }else{
      return <p style={{textAlign:"center"}}>( Development environment - stackla disabled. Boo! )</p>
    }

  }

}


const mapStateToProps = state => {
  return{
    filteredItinerary:state.currentBooking.filteredItinerary
  }
}


export default connect(mapStateToProps, null)(StacklaWidget);
